import fetch from '@/utils/fetch'
import constants from '@/utils/constants'

/**
 * 饮水统计
 * @param params
 */
export const drinkInfoStatic = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/orgaize/drinkingInfo/statistics',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 * 饮水数据导出
 */
export const exportDrinkData = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/orgaize/drinkingInfo/export',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 * 晨检统计柱状图
 */
export const morningCheckStatic = (params:any) => fetch({
  url: constants.API_MODULE_PATH.HEALTH + '/organize/studentHealth/statistics',
  method: 'post',
  data: {
    ...params
  }
})

/**
 * 晨检统计饼状图
 */
export const morningCheckPieStatic = (params:any) => fetch({
  url: constants.API_MODULE_PATH.HEALTH + '/organize/studentHealth/checkPieChart',
  method: 'post',
  data: {
    ...params
  }
})

/**
 * 晨检统计检查人数
 */
export const morningCheckNumber = (params:any) => fetch({
  url: constants.API_MODULE_PATH.HEALTH + '/organize/studentHealth/checkCount',
  method: 'post',
  data: {
    ...params
  }
})

/**
 * 晨检统计检查人数
 */
export const healthExport = (params:any) => fetch({
  url: constants.API_MODULE_PATH.HEALTH + '/organize/studentHealth/export',
  method: 'post',
  data: {
    ...params
  }
})

/**
 * 手环异常监控导出
 */
export const braceletExport = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/orgaize/bracelet/exportList',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 * 手环详细数据导出
 */
export const braceletExportDetail = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/orgaize/bracelet/exportDetailList',
    method: 'post',
    data: {
      ...params
    }
  })
}
